import { SlideUpLine, FadeUp, Stagger, StaggerItem, ScaleIn } from "@/pages/_shared/anim";
import Technician from "../../../assets/About1.jpg"
import { Link } from "react-router-dom";

const capabilities = [
  {
    icon: "ri-brain-line",
    title: "TECHNICAL KNOWLEDGE",
    desc: "Specialized support for elevator and escalator systems.",
  },
  {
    icon: "ri-stack-line",
    title: "MULTI-BRAND SUPPORT",
    desc: "Technical solutions and spare parts across multiple brands.",
  },
  {
    icon: "ri-settings-3-line",
    title: "COMPLETE SOLUTIONS",
    desc: "From a single component to a complete elevator installation.",
  },
];

export default function About() {
  return (
    <section id="about" className="bg-crest-cream py-20 md:py-28">
      <div className="px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <FadeUp>
              <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-crest-deep/60 uppercase">
                <span className="w-6 h-px bg-crest-deep/40" /> About Uplift One
              </span>
            </FadeUp>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-crest-deep leading-tight mt-5">
              <SlideUpLine as="div">Technical Expertise.</SlideUpLine>
              <SlideUpLine as="div" delay={0.1}>
                <span className="text-crest-bg">Practical Solutions.</span>
              </SlideUpLine>
              <SlideUpLine as="div" delay={0.2}>One Reliable Partner.</SlideUpLine>
            </h2>

            <ScaleIn className="mt-8 rounded-lg overflow-hidden" delay={0.2}>
              <div
                className="w-full h-72 md:h-80"
                style={{
                  backgroundImage:
                    `url(${Technician})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              />
            </ScaleIn>
          </div>

          <div className="lg:col-span-7 lg:pl-10">
            <FadeUp delay={0.1}>
              <p className="text-crest-deep/80 text-lg md:text-xl leading-relaxed">
                Uplift One Elevator Solutions Hub provides comprehensive technical solutions for elevators, escalators, and vertical and inclined transportation systems.
              </p>
            </FadeUp>
            <FadeUp delay={0.2}>
              <p className="text-crest-deep/70 text-base md:text-lg leading-relaxed mt-5">
                From complete elevator supply and installation to specialized technical services and hard-to-find spare parts, we help customers identify problems, find practical solutions, and keep their systems operating reliably.
              </p>
            </FadeUp>

            <Stagger className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10" stagger={0.1}>
              {capabilities.map((c) => (
                <StaggerItem
                  key={c.title}
                  className="bg-white rounded-lg p-5 border border-black/5 hover:border-crest-orange/60 transition-colors"
                >
                  <span className="w-10 h-10 flex items-center justify-center rounded-md bg-crest-orange text-white">
                    <i className={`${c.icon} text-lg`}></i>
                  </span>
                  <h3 className="font-display text-lg text-crest-deep mt-4">
                    {c.title}
                  </h3>
                  <p className="text-sm text-crest-deep/70 mt-2 leading-relaxed">
                    {c.desc}
                  </p>
                </StaggerItem>
              ))}
            </Stagger>

            <FadeUp delay={0.2} className="mt-10 flex flex-wrap items-center gap-6">
              <Link
                to="/solutions"
                className="inline-flex items-center gap-2 bg-crest-orange text-white hover:bg-crest-orangeLight transition-colors px-6 py-3 rounded-full text-sm font-medium cursor-pointer whitespace-nowrap"
              >
                Explore our solutions
                <i className="ri-arrow-right-up-line"></i>
              </Link>
              <Link
                to="/spare-parts"
                className="inline-flex items-center gap-2 border border-crest-deep/30 text-crest-deep hover:bg-crest-deep hover:text-crest-orange hover:border-crest-deep transition-colors px-6 py-3 rounded-full text-sm font-medium cursor-pointer whitespace-nowrap"
              >
                Find spare parts
                <i className="ri-arrow-right-up-line"></i>
              </Link>
            </FadeUp>
          </div>
        </div>
      </div>
    </section>
  );
}